<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">发票管理</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">发票信息管理</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">发票信息管理</div>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn z-margin-bottom-20-precent">
          <p>请您完善以下发票信息，将以此作为发票抬头信息：</p>
        </div>
        <el-form label-position="right" class="auth-form" ref="ruleForm" label-width="180px" :model="authForm">
          <el-form-item label="收件地址：" prop="name">
          <el-input v-model="authForm.address"></el-input>
        </el-form-item>
          <el-form-item label="联系人：" prop="name">
            <el-input v-model="authForm.linkman"></el-input>
          </el-form-item>
          <el-form-item label="联系手机：" prop="name">
            <el-input v-model="authForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="开具类型：" prop="name">
            <el-radio-group v-model="authForm.ktype" size="small">
              <el-radio-button label="个人"></el-radio-button>
              <el-radio-button label="企业"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头：" prop="name">
            <el-input v-model="authForm.taitou"></el-input>
            <span v-show="authForm.ktype == '个人'" class="z-margin-left-20-precent">请填写真实个人姓名</span>
            <span v-show="authForm.ktype == '企业'" class="z-margin-left-20-precent">请与营业执照上名称保持一致</span>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业'" label="发票类型：">
            <el-radio-group v-model="authForm.ftype" size="small">
              <el-radio-button label="增值税普通发票"></el-radio-button>
              <el-radio-button label="增值税专用发票"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业'" label="税务登记号：">
            <el-input v-model="authForm.nsrsbh"></el-input>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业' && authForm.ftype == '增值税专用发票'" label="基本开户银行名称：">
            <el-input v-model="authForm.khhmc"></el-input>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业' && authForm.ftype == '增值税专用发票'" label="基本开户银行账号：">
            <el-input v-model="authForm.khhzh"></el-input>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业' && authForm.ftype == '增值税专用发票'" label="注册场地地址：">
            <el-input v-model="authForm.zcdz"></el-input>
          </el-form-item>
          <el-form-item v-show="authForm.ktype == '企业' && authForm.ftype == '增值税专用发票'" label="注册场地电话：">
            <el-input v-model="authForm.zcdh"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="border-radius: 0" @click="submitForm('ruleForm')">保存信息</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import caiwuService from 'business/caiwuService.js'
  export default {
    data() {
      return {
        listLoading:false,
        authForm:{
          address:'',
          linkman:'',
          ktype:'个人',
          taitou:'',
          tel:'',
          ftype:'增值税普通发票',
          nsrsbh:'',
          khhmc:'',
          khhzh:'',
          zcdz:'',
          zcdh:'',
        },
      }
    },
    components:{

    },
    props:{
      hide:Boolean
    },
    computed: {
      ktype() {
        return this.authForm.ktype
      },
    },
    watch:{
      ktype(val) {
        if(val === '个人') {
          this.authForm.ftype = '增值税普通发票'
        }
      }
    },
    mounted() {

    },
    methods:{
      async submitForm() {
        let ftype = this.authForm.ktype === '个人' ? 0 : (this.authForm.ftype === '增值税普通发票' ? 1 : 2)
        let data = 'cmd=invoice_mod_set'+
          '&address='+ this.authForm.address +
          '&linkman='+ this.authForm.linkman +
          '&fplx='+ ftype +
          '&taitou='+ this.authForm.taitou +
          '&tel='+ this.authForm.tel +
          '&nsrsbh='+ this.authForm.nsrsbh +
          '&khhmc='+ this.authForm.khhmc +
          '&khhzh='+ this.authForm.khhzh +
          '&zcdz='+ this.authForm.zcdz +
          '&zcdh='+ this.authForm.zcdh
        this.dialogLoading = true
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.$router.push('/invoiceinfo')
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .auth-form .el-input {
    width: 440px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/caiwu/invoiceadd.vue